import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { WebSocketService } from '../../services/websocket.service';
import { Subscription } from 'rxjs';
import { Logout } from '@store/auth/auth.actions';
import { Store } from '@ngxs/store';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { CountdownConfig, CountdownEvent } from 'ngx-countdown';

export interface DuplicateLoginDialogData {
  sessionIdWs: string;
  username?: string;
}

@Component({
  selector: 'app-duplicate-login-dialog',
  templateUrl: './duplicate-login-dialog.component.html',
  styleUrls: ['./duplicate-login-dialog.component.scss'],
})
export class DuplicateLoginDialogComponent
  implements OnInit, OnDestroy
{
  @Input() data: DuplicateLoginDialogData;
  userNameWs: string | undefined;
  config: CountdownConfig = { leftTime: 10, notify: 0 }; // set follow duplicate waiting time
  private subscription = new Subscription();

  constructor(
    public activeModal: NgbActiveModal,
    private store: Store,
    private websocketService: WebSocketService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private authService: AuthenticationService,
  ) {}

  ngOnInit(): void {
    // Initialize from data passed when dialog was opened so pong/other messages can't wipe it
    this.userNameWs = this.data?.username;
    this.subscription.add(
      this.websocketService.messagesSubject.subscribe((messages) => {
        if (messages?.username) {
          this.userNameWs = messages.username;
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  allowLogin(): void {
    if (
      this.userNameWs ===
      this.authService.currentUserInfo.user.username
    ) {
      this.websocketService.respondToDuplicateLogin(
        true,
        this.data.sessionIdWs,
        this.userNameWs,
      );
    }
    this.spinner.show();
    this.activeModal.dismiss();
    this.store.dispatch(new Logout());
    setTimeout(() => {
      window.location.href = '/login';
    }, 500);
  }

  denyLogin(): void {
    this.websocketService.respondToDuplicateLogin(
      false,
      this.data.sessionIdWs,
    );
    this.activeModal.dismiss();
  }

  resetPassword(): void {
    this.activeModal.dismiss();
    this.router.navigate(['profile-detail', 'edit-password']);
  }

  handleEvent(event: CountdownEvent): void {
    if (event.action === 'done') {
      this.activeModal.dismiss();
    }
  }
}
